import React from "react"
import { isMobile } from "react-device-detect"
import { withRouter } from "react-router-dom"
import { view } from "react-easy-state"
import { Button, message, Result } from "antd"

import Header from "components/common/layouts/Header"
import Footer from "components/common/layouts/Footer"
import ContentLoader from "components/common/ContentLoader"
import ContentLoadingFailed from "components/common/ContentLoadingFailed"
// import AskDoubt from "components/pages/students/AskDoubt"

import globalStore from "store"
// import * as AuthHelper from "helpers/auth.helper"

import CourseSubscriptionsService from "services/students/course_subscriptions.service"
import CourseService from "services/students/courses.service"

class StudentsCoursesPaymentPage extends React.Component {
  state = {
    payNowButtonLoading: false,
  }

  async componentDidMount() {
    const { courseId } = this.props.match.params
    const pageState = globalStore.ui.students.courses.payment

    await CourseService.payment({ pageState, courseId })
  }

  makePayment = (course) => {
    this.setState({ payNowButtonLoading: true })

    let options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID,
      amount: parseInt(course.fee) * 100, // 2000 paise = INR 20, amount in paisa
      name: "Learner",
      description: "Course subscription",
      handler: async (response) => {
        console.log("Razorpay response", JSON.stringify(response))
        console.log("rzp response", response)

        const razorpayPaymentId = response.razorpay_payment_id

        if (!razorpayPaymentId) {
          message.destroy()
          message.error("Oops!! something went wrong")
          this.setState({ payNowButtonLoading: false })
          return
        }

        const pageState = globalStore.ui.students.course_subscriptions.payment
        const courseId = course.id

        await CourseSubscriptionsService.payment({
          pageState,
          courseId,
          razorpayPaymentId,
        })

        if (pageState.API_COURSE_SUBSCRIPTIONS_PAYMENT_STATUS === "fulfilled") {
          const { payment } = globalStore.ui.students.course_subscriptions

          let pageToRedirect = "Subject"
          let redirectToUrl = `/courses/${pageState.payment.course_id}/subjects`

          if (payment.subjectId && payment.paperId) {
            pageToRedirect = "Test paper"
            redirectToUrl = `/papers/${payment.paperId}`
          }

          const title = "Successfully Purchased Course!"
          const subTitle = `Congratulations!! Now you can access test papers of this course. (Payment ID: ${razorpayPaymentId})`

          this.setState({
            result: {
              status: "success",
              title,
              subTitle,
              redirectToUrl,
              pageToRedirect,
            },
          })
        } else {
          const title = "Oops!! something went wrong"
          const subTitle = `Your Payment ID: ${razorpayPaymentId}`

          this.setState({
            payNowButtonLoading: false,
            result: {
              status: "warning",
              title,
              subTitle,
            },
          })
        }
        console.log(pageState)
      },
    }

    const razorpay = new window.Razorpay(options)

    razorpay.on("payment.error", ({ error }) => {
      console.log("errors", error)
      message.destroy()
      message.error(error.description)
      this.setState({ payNowButtonLoading: false })
    })
    razorpay.open()
  }

  renderResult = () => {
    const { status, title, subTitle, redirectToUrl, pageToRedirect } = this.state.result

    return (
      <Result
        status={status}
        title={title}
        subTitle={subTitle}
        extra={
          status === "warning"
            ? [
                <Button type="primary" onClick={() => this.props.history.push(`/courses`)}>
                  Go Back
                </Button>,
              ]
            : [
                <Button type="primary" onClick={() => this.props.history.push(`${redirectToUrl}`)}>
                  Explore {pageToRedirect}
                </Button>,
              ]
        }
      />
    )
  }

  courseDetailWithPayment = (course) => {
    const { payNowButtonLoading } = this.state

    return (
      <div style={{ textAlign: "center", padding: 50, marginTop: 100 }}>
        <h1>Payment Amount: Rs. {course.fee}</h1>
        <h4>After successful payment, course evaluation feature will be enabled.</h4>
        <Button
          type="primary"
          style={{ margin: 20 }}
          onClick={() => this.makePayment(course)}
          loading={payNowButtonLoading}
        >
          Pay Now
        </Button>
      </div>
    )
  }

  renderPageContent() {
    const pageState = globalStore.ui.students.courses.payment
    const { course, courseErrors, API_COURSES_PAYMENT_STATUS } = pageState

    if (!API_COURSES_PAYMENT_STATUS) return <ContentLoader />
    if (API_COURSES_PAYMENT_STATUS === "pending") return <ContentLoader />
    if (API_COURSES_PAYMENT_STATUS === "rejected") return <ContentLoadingFailed />

    if (courseErrors) {
      const { courseId } = this.props.match.params
      message.destroy()
      message.error(courseErrors)
      this.props.history.replace(`/courses/${courseId}/subjects`)
      return
    }

    const courseSubscription = pageState.course_subscription
    const evaluation_feature =
      courseSubscription && courseSubscription.subscription_features.filter((s) => s.feature === "evaluation")

    if (!evaluation_feature || evaluation_feature.length === 0) {
      return <div>{this.courseDetailWithPayment(course)}</div>
    } else {
      this.props.history.push(`/courses/${course.id}/subjects`)
    }
  }

  componentWillUnmount() {
    globalStore.ui.students.courses.payment = {}
  }

  render() {
    const { result } = this.state
    // const { course } = globalStore.ui.students.courses.payment

    // const headerContent = (
    //   <React.Fragment>
    //     <div className="top-bar">
    //       <div>
    //         <Button type="link" onClick={() => this.props.history.push(`/courses/${course.id}/subjects`)}>
    //           <Icon type="arrow-left" />
    //         </Button>
    //         <Button style={{ padding: 0 }} type="link" onClick={() => this.props.history.push("/")}>
    //           <h1>Learner</h1>
    //         </Button>
    //       </div>
    //     </div>
    //     <div className="top-menu-wrapper">
    //       {!isMobile && (
    //         <React.Fragment>
    //           <Button type="link" onClick={() => this.props.history.push("/courses")}>
    //             Courses
    //           </Button>
    //           <Button type="link" onClick={() => this.props.history.push("/doubts")}>
    //             My doubts
    //           </Button>
    //           <Button type="link" onClick={() => this.props.history.push("/doubts/all")}>
    //             All doubts
    //           </Button>
    //           <Button type="link" onClick={() => this.props.history.push("/profile")}>
    //             Profile
    //           </Button>
    //           <AskDoubt
    //             buttonText="Ask a doubt"
    //             buttonType="link"
    //             buttonStyle={{
    //               position: "initial",
    //               display: "flex",
    //               justifyContent: "flex-end",
    //             }}
    //           />
    //           <Button type="link" onClick={() => AuthHelper.logout()}>
    //             Logout
    //           </Button>
    //         </React.Fragment>
    //       )}
    //       {/* <ul className="top-menu">
    //       <li><a href="/">My Courses</a></li>
    //       <li><a href="/">All Courses</a></li>
    //       <li><a href="/">Account</a></li>
    //     </ul> */}
    //     </div>
    //   </React.Fragment>
    // )

    return (
      <div className={`page course-page ${isMobile ? "mobile" : ""}`}>
        <Header />
        <div className="page-content">{result ? this.renderResult() : this.renderPageContent()}</div>
        <Footer />
      </div>
    )
  }
}

export default withRouter(view(StudentsCoursesPaymentPage))
